import type { FC } from 'react';
import { memo } from 'react';

import { BaseStepCountStepsListStyled } from './styles/BaseStepCountStepsListStyled'
import { type StepCountCommonProps } from '../../types'

export const BaseStepCountStepsList: FC<StepCountCommonProps> =
  memo((props) => {
    const {
      children,
      stepCountProps: { clickable = false },
    } = props

    return (
      <BaseStepCountStepsListStyled clickable={clickable}>
        {children}
      </BaseStepCountStepsListStyled>
    )
  })

BaseStepCountStepsList.displayName = 'BaseStepCountStepsList'
